// Utils
import {
  localMobilePhoneValidator,
  prettifyPhoneNumber,
} from '@shopee-user/authentication-utils';
import { PHONE_REGEX, looseEmail } from '@shopee/validators';

// Types
import type { TypedFormConfig } from '@shopee/use-form-hook';
import type { LoginByOtpFormShape } from '@shopee-user/business-customization-types';

function phoneOrEmailValidator({
  requiredErrorMessage,
  phoneErrorMessage,
  emailErrorMessage,
}: {
  requiredErrorMessage: string;
  phoneErrorMessage: string;
  emailErrorMessage: string;
}) {
  return (
    value: string
  ): string | null | undefined | Promise<string | null | undefined> => {
    if (!value) {
      return requiredErrorMessage;
    } else if (PHONE_REGEX.test(value)) {
      return localMobilePhoneValidator(phoneErrorMessage)(value);
    } else {
      return looseEmail(emailErrorMessage)(value);
    }
  };
}

export const FORM_CONFIG: TypedFormConfig<LoginByOtpFormShape> = {
  authKey: {
    type: 'string',
    initialValue: '',
    validators: [
      phoneOrEmailValidator({
        requiredErrorMessage: 'msg_auth_mandatory_field',
        phoneErrorMessage: 'msg_auth_invalid_phone',
        emailErrorMessage: 'msg_auth_invalid_email',
      }),
    ],
    transform: prettifyPhoneNumber,
  },
};
